import { Link } from "react-router-dom";
import stylesE from "../../../layout/admin/Error.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";

const Error404Admin = () => {
  return (
    <div className={stylesE.main}>
      <ScreenTitle>404エラー</ScreenTitle>
      <SubScreenTitle>
        ご指定のページまたはファイルは見つかりませんでした
      </SubScreenTitle>
      <label>
        「渋谷生涯活躍ネットワーク・シブカツ(通称：シブカツ)」サイトにアクセスしていただきありがとうございます。
        <br></br>
        大変申し訳ございませんが、該当するページが以下のような理由で存在しません。
      </label>
      <div className={stylesE.li_box}>
        <li>すでに削除されて無効になっている。</li>
        <li>URLの入力やリンク先が間違っている、変更されている。</li>
        <li>一時的にアクセスが出来なくなっている。</li>
      </div>
      <Link to="../top">トップページ</Link>
    </div>
  );
};

export default Error404Admin;
